"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaUpload = void 0;
var react_1 = require("@chakra-ui/react");
var React = __importStar(require("react"));
var MediaContext_1 = require("../MediaContext");
var Icon_1 = require("../../Icon");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var FileInput_1 = require("./FileInput");
function MediaUpload(_a) {
    var _this = this;
    var openInUploadView = _a.openInUploadView;
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    var _js = mediaContext._js;
    var _b = mediaContext.getMediaBlurbs(), filetypesBlurb = _b.filetypesBlurb, sizeBlurb = _b.sizeBlurb;
    var _c = React.useState(''), url = _c[0], setUrl = _c[1];
    var onChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!e.target.files) {
                return [2 /*return*/];
            }
            mediaContext.uploadMediaItems(Array.from(e.target.files));
            return [2 /*return*/];
        });
    }); };
    var uploadFileByUrl = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!url)
                        return [2 /*return*/];
                    return [4 /*yield*/, mediaContext.importMediaByUrl(url)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(react_1.ModalHeader, null,
            React.createElement(react_1.Flex, { justify: "space-between", position: "relative" },
                React.createElement(react_1.Heading, { display: { base: 'none', md: 'block' }, position: "absolute", textAlign: "center", width: "100%", 
                    // Resetting styles that get applied in the monolith
                    borderBottom: "none", m: 0 }, _js('Add New Media')),
                React.createElement(react_1.Button, { variant: "outline", onClick: function () { return mediaContext.setView('list'); }, "data-feature-id": "media_manager_import_back" },
                    React.createElement(Icon_1.Icon, { type: pro_regular_svg_icons_1.faArrowLeft, mr: 2 }),
                    _js('Back')))),
        React.createElement(react_1.ModalBody, { display: "flex", flexDirection: "column" },
            React.createElement(react_1.Flex, { direction: "column", border: "2px dashed", borderRadius: "md", borderWidth: "1px", borderColor: "gray.400", flex: 1, mb: 4, p: "4" },
                React.createElement(FileInput_1.FileInput, { onChange: onChange, mediaContext: mediaContext, flex: 1, openInUploadView: openInUploadView }),
                React.createElement(react_1.Flex, { direction: 'column', gap: 2, mt: 4 },
                    React.createElement("p", null, filetypesBlurb),
                    React.createElement("p", null, sizeBlurb))),
            React.createElement(react_1.Box, { mb: 4 },
                React.createElement(react_1.Flex, { width: "100%", direction: "column", alignItems: "center", gap: 2 },
                    React.createElement(react_1.Text, null, _js('or upload by URL')),
                    React.createElement(react_1.Input, { "aria-label": _js('Import URL'), placeholder: "http://", value: url, onChange: function (e) { return setUrl(e.target.value); } })),
                React.createElement(react_1.Flex, { mt: "2", justifyContent: "flex-end" },
                    React.createElement(react_1.Button, { backgroundColor: "blue.500", _hover: {
                            backgroundColor: 'blue.600',
                        }, color: "white", isDisabled: !url, onClick: uploadFileByUrl, "data-feature-id": "media_manager_import_grab_media" }, _js('Grab media')))))));
}
exports.MediaUpload = MediaUpload;
